import { classNames } from '@repo/ui/src/utils/classNames';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';
import { appConfig } from '../../utils/appConfig';

interface LeftChevronProps extends IconWrapperProps {
  darkMode?: boolean;
  onImage?: boolean;
  arrowSize?: string;
}

const LeftChevron = ({ darkMode, onImage, arrowSize, ...rest }: LeftChevronProps) => {
  const lightMode = !darkMode && !onImage;

  return (
    <IconWrapper
      width={arrowSize ?? '40'}
      height={arrowSize ?? '40'}
      viewBox="0 0 48 48"
      className={classNames(
        darkMode && appConfig.isTraeger && 'fill-neutral-100 hover:fill-warm-400',
        darkMode && appConfig.isMeater && 'fill-brand-300 hover:fill-red-400',
        onImage && 'fill-neutral-100 hover:fill-neutral-500',
        lightMode && 'fill-neutral-700 hover:fill-warm-400',
      )}
      {...rest}
    >
      <circle cx="24" cy="24" r="24" fill="inherit" transform="rotate(-180 24 24)" />
      <path
        className={classNames(lightMode ? 'fill-neutral-100' : 'fill-neutral-700')}
        fillRule="evenodd"
        d="m27 33.9 1.414-1.415L19.93 24l8.485-8.485L27 14.1l-8.485 8.486L17.1 24l1.415 1.414L27 33.9Z"
        clipRule="evenodd"
      />
    </IconWrapper>
  );
};

export default LeftChevron;
